// extracted by mini-css-extract-plugin
export var checkbox = "checkboxBlock-module--checkbox--c9iWe";
export var checkboxBlock = "checkboxBlock-module--checkboxBlock--+FJDR";
export var hintIconClose = "checkboxBlock-module--hintIconClose---gkaD";
export var hintText = "checkboxBlock-module--hintText--5z+OA";
export var iconButtonRoot = "checkboxBlock-module--iconButtonRoot--CkF-m";
export var round = "checkboxBlock-module--round--zYNcH";
export var slider = "checkboxBlock-module--slider--uE0Xy";
export var text = "checkboxBlock-module--text--6c3dB";
export var tooltip = "checkboxBlock-module--tooltip--u-P54";
export var tooltipIcon = "checkboxBlock-module--tooltipIcon--hy8yN";